import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import GlobalActionsPage from './global-actions-page';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Global Actions">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >Master Data</Breadcrumb.Item>
            <Breadcrumb.Item active>Global Actions</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <GlobalActionsPage />
    </Panel>
  );
};

export default Page;
